/*
  ワンタイムトークン
 */
import axios from "axios/index";
axios.defaults.withCredentials = true;
export const axiosWithToken = axios.create();
const getToken = () => new Promise((resolve, reject) => {
    const url = '/gift/api/token/get';
    return axios({ url, method: 'get' })
        .then((response) => {
            resolve(response.data.onetime_token);
        });
});
axiosWithToken.interceptors.request.use((config) => {
    return getToken()
        .then((onetime_token) => {
            config.data.token = onetime_token;
            config.headers.Authorization = 'Bearer ' + onetime_token;
            return config;
        });
});
export const axiosWithOutTokenWithAccessToken = axios.create();
axiosWithOutTokenWithAccessToken.interceptors.request.use((config) => {
    const auth = JSON.parse(sessionStorage.getItem('auth'),true);
    config.headers.Authorization = `${auth.access_token}`;
    return config;
});

export const axiosWithOutToken = axios.create();
axiosWithOutToken.interceptors.request.use((config) => {
    return config;
});
export const noAction = function () {
    console.log('');
};
